<template>
  <div class="desp">
    <div class="desp-header">
      <div class="label">Fee Letter</div>
      <el-button
        :loading="submitLoading"
        @click="dataFormSave"
        v-if="
          (detail.applymentStatus === 'INQUIRING' || detail.applymentStatus === 'QUOTING' || detail.applymentStatus === 'QUOTATION_AUDIT_FAIL') &&
          isApplymentAuth('quotation:coordinate')
        "
      >
        Save
      </el-button>
    </div>
    <el-form class="feeLetterForm" :model="dataForm" ref="dataForm" label-position="top">
      <div class="pb50 desp-items-group">
        <p class="desp-items-group-title">1. About This Fee Letter 关于本收费协议</p>
        <div class="desp-item">
          <div class="desp-item-self">
            <div class="pb30">
              <p class="lh22" v-if="detail.businessType == 'COMPREHENSIVE_CUSTOMIZED'">
                1.1 We thank you for giving us the opportunity to provide our services. This letter explains our service scope and fee information that
                apply when you use the comprehensive corporate services provided by us.
                感谢您选择我们的服务。本协议解释了您使用我们提供的综合企业服务时适用的服务范围和费用信息。
              </p>
              <p class="lh22" v-else-if="detail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
                1.1 We thank you for giving us the opportunity to provide our services. This letter explains our service scope and fee information that
                apply when you use the fund admin services and other add-on services provided by us.
                感谢您选择我们的服务。本协议解释了您使用我们提供的基金托管及其他附加服务时适用的服务范围和费用信息。
              </p>
            </div>
            <div class="pb30">
              <p class="lh22" v-if="detail.businessType == 'COMPREHENSIVE_CUSTOMIZED'">
                1.2 Unless otherwise mentioned in this letter, all terms and conditions are also subject to the Service Agreement that will be acknowledged
                by you when you use our comprehensive corporate services.
                除本协议另有说明外，所有条款和条件均受您在使用我们的综合企业服务时确认的《服务协议》的约束。
              </p>
              <p class="lh22" v-else-if="detail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
                1.2 Unless otherwise mentioned in this letter, all terms and conditions are also subject to the Service Agreement that will be acknowledged
                by you when you use our fund admin services and other add-on services.
                除本协议另有说明外，所有条款和条件均受您在使用我们的基金托管及其他附加服务时确认的《服务协议》的约束。
              </p>
            </div>
            <div class="pb30">
              <el-form-item
                :label="`1.3 This letter is subject to the engagement letter with transaction number [${dataForm.newTransactionNumber}]. For the specific services covered by this letter, the terms and conditions of this letter with transaction number [${dataForm.transactionNumber}] shall prevail.
                本协议受交易代码为[${dataForm.newTransactionNumber}]的业务约定书约束。就本协议所涵盖的具体服务而言，以交易代码为[${dataForm.transactionNumber}]的本协议所载条款和条件为准。`"
                prop="newTransactionNumber"
                ref="newTransactionNumber"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.newTransactionNumber" placeholder="基于交易代码" class="wd500"></el-input>
              </el-form-item>
              <el-form-item
                prop="transactionNumber"
                ref="transactionNumber"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.transactionNumber" placeholder="先前交易代码" class="wd500"></el-input>
              </el-form-item>
            </div>
            <div class="pb30">
              <el-form-item
                :label="`1.4 By the &quot;we&quot;, &quot;us&quot;, “our”, &quot;ours&quot; we mean ${dataForm.companyName}, including its affiliates and its assigned
                service provider(s). 协议中提及的“我方”、“我们”、“我方的”、“我们的”是指 ${dataForm.companyName}，并包括其附属公司及其指定的服务提供商。`"
                prop="companyName"
                ref="companyName"
                :rules="{
                  required: true,
                  message: 'Please add quotation first',
                  trigger: 'submit',
                }"
              ></el-form-item>
            </div>
            <div class="pb30">
              <p class="lh22" v-if="detail.businessType == 'COMPREHENSIVE_CUSTOMIZED'">
                1.5 This letter is by and between the Company to be incorporated/transferred/customized per the request(s) through our Electronic Services
                (hereinafter called “the Company”), and us. Each shall be referred to as a “Party” and collectively referred to as the “Parties”.
                本协议的签署方为:
                通过我们的电子服务系统申请成立/转让/定制化的公司（以下简称“贵公司”）和我方签署。以下的单指某方简称“一方”，以下的统称简称“各方”。
              </p>
              <div v-else-if="detail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
                <el-form-item
                  :label="`1.5 This letter is by and between the fund(s) named [${dataForm.fundNameList}] per the request(s) through our Electronic Services
                (hereinafter called “the Fund(s)”), and us. Each shall be referred to as a “Party” and collectively referred to as the “Parties”.
                本协议的签署方为:
                通过我们的电子服务系统提交申请的基金[${dataForm.fundNameList}](以下简称“贵基金”)和我方签署。以下的单指某方简称“一方”，以下的统称简称“各方”。`"
                  prop="fundNameList"
                  ref="fundNameList"
                  :rules="{
                    required: true,
                    message: 'Please select',
                    trigger: 'submit',
                  }"
                >
                  <el-select v-model="dataForm.fundNameList" multiple placeholder="选择基金" class="wd500">
                    <el-option v-for="fun in detail.fundInfoList" :key="fun.id" :label="fun.fundName" :value="fun.fundName"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="pb30">
              <p class="lh22">1.6 {{ governingLawClause.en }} {{ governingLawClause.cn }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pb50 desp-items-group">
        <div>
          <p class="desp-items-group-title" v-if="detail.businessGenre == 'COMPANY'">2. Introduction 引言</p>
          <p class="desp-items-group-title" v-else-if="detail.businessGenre == 'FUND'">2. General Terms and Conditions 一般条款和条件</p>
          <div class="desp-item">
            <div class="desp-item-self">
              <div class="pb30" v-if="detail.businessGenre == 'COMPANY'">
                <el-form-item
                  label="2.1 Based on our previous communication with you, we understand that: "
                  prop="introduction"
                  ref="introduction"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-editor :height="400" class="editor" v-model="dataForm.introduction" />
                </el-form-item>
                <el-form-item
                  label="2.1 根据之前的沟通，我们理解："
                  prop="introductionCn"
                  ref="introductionCn"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-editor :height="400" class="editor" v-model="dataForm.introductionCn" />
                </el-form-item>
              </div>
              <div class="pb30" v-else-if="detail.businessGenre == 'FUND'">
                <div class="lh22 fs14 fwb black45 pb10">
                  <span class="danger">*</span>
                  WHEREAS, the Fund(s) to be managed by {{ detail.questionnaire.proposedCompanyName }} (the “Fund Manager”), and the Fund(s) desires to
                  appoint us [{{ dataForm.fundManagerRole }}] of the Fund(s). NOW, THEREFORE, in consideration of the mutual promises and agreements
                  contained herein, the parties hereby agree as follows:
                </div>
                <el-form-item
                  prop="fundManagerRole"
                  ref="fundManagerRole"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-input v-model="dataForm.fundManagerRole" placeholder="角色(EN)" class="wd500" />
                </el-form-item>
                <el-form-item
                  prop="introduction"
                  ref="introduction"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-editor :height="400" class="editor" v-model="dataForm.introduction" />
                </el-form-item>
                <div class="lh22 fs14 fwb black45 pb10">
                  <span class="danger">*</span>
                  鉴于贵基金由{{ detail.questionnaire.proposedCompanyName }}(以下简称“贵基金管理公司”)管理，以及贵基金希望任命我方为基金[{{
                    dataForm.fundManagerRoleCn
                  }}]。 因此，现依据以下包含的相互承诺和协议，各方特此同意如下：
                </div>
                <el-form-item
                  prop="fundManagerRoleCn"
                  ref="fundManagerRoleCn"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-input v-model="dataForm.fundManagerRoleCn" placeholder="角色(CN)" class="wd500" />
                </el-form-item>
                <el-form-item
                  prop="introductionCn"
                  ref="introductionCn"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-editor :height="400" class="editor" v-model="dataForm.introductionCn" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pb50 desp-items-group">
        <p class="desp-items-group-title">3. Service Scope and Fees 服务范围以及报价</p>
        <div class="desp-item">
          <div class="desp-item-self">
            <div class="pb30">
              <el-form-item
                :label="`3.1 Based on our understanding of the ${detail.businessGenre == 'COMPANY' ? 'Company' : 'Fund(s)'} as set out in ${
                  detail.businessGenre == 'COMPANY' ? 'section 2' : 'Clause 1, 2 and 3.1.1'
                } of this letter, we will assign [${dataForm.principal}] as the person-in-charge for the provision of services specified as below:`"
                prop="principal"
                ref="principal"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.principal" placeholder="负责人(EN)" class="wd500"></el-input>
              </el-form-item>
              <el-form-item
                prop="serviceScopeAndFeesUrl.url"
                ref="serviceScopeAndFeesUrl.url"
                :rules="{
                  required: true,
                  message: 'Please upload',
                  trigger: 'submit',
                }"
              >
                <el-image-uploader v-model="dataForm.serviceScopeAndFeesUrl"></el-image-uploader>
                <el-input v-model="dataForm.serviceScopeAndFeesUrl.url" style="display: none"></el-input>
              </el-form-item>

              <el-form-item
                :label="`3.1 鉴于本协议${detail.businessGenre == 'COMPANY' ? '第2条' : '第1条、第2条和第3.1.1条'}提及的我们对贵${
                  detail.businessGenre == 'COMPANY' ? '公司' : '基金'
                }的理解，我们将安排[${dataForm.principalCn}]为项目的负责人，我们对贵${detail.businessGenre == 'COMPANY' ? '公司' : '基金'}的收费报价如下:`"
                prop="principalCn"
                ref="principalCn"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.principalCn" placeholder="负责人(CN)" class="wd500"></el-input>
              </el-form-item>
              <el-form-item
                prop="serviceScopeAndFeesCnUrl.url"
                ref="serviceScopeAndFeesCnUrl.url"
                :rules="{
                  required: true,
                  message: 'Please upload',
                  trigger: 'submit',
                }"
              >
                <el-image-uploader v-model="dataForm.serviceScopeAndFeesCnUrl"></el-image-uploader>
                <el-input v-model="dataForm.serviceScopeAndFeesCnUrl.url" style="display: none"></el-input>
              </el-form-item>
            </div>
            <div class="pb30">
              <p class="lh22" v-if="detail.businessGenre == 'COMPANY'">
                Our above quotation is based on our standard fees, our understanding of the Company's business and long-term needs, and the discretionary
                discounts given to future long-term relationship. 我们的上述报价是基于我们的标准费用1
                、我们了解的公司情况及长期需求、以及未来长期合作关系给予的酌情折扣得出。
              </p>
              <p class="lh22" v-if="detail.businessGenre == 'FUND'">
                Our above quotation is based on our standard fees, our understanding of the Fund(s)'s business and long-term needs, and the discretionary
                discounts given to future long-term relationship. 我们的上述报价是基于我们的标准费用1
                、我们了解的贵基金的运营情况及长期需求、以及未来长期合作关系给予的酌情折扣得出。
              </p>
            </div>
            <div class="pb30">
              <el-form-item
                label="Notes:"
                prop="notes"
                ref="notes"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-editor :height="400" class="editor" v-model="dataForm.notes" />
              </el-form-item>
              <el-form-item
                label="说明:"
                prop="notesCn"
                ref="notesCn"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-editor :height="400" class="editor" v-model="dataForm.notesCn" />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="pb50 desp-items-group">
        <p class="desp-items-group-title">4. Fee Schedule 收费安排</p>
        <div class="desp-item">
          <div class="desp-item-self">
            <div class="pb30">
              <el-form-item
                :label="`4.1 Our fee set out in section 3 shall be billed on [${dataForm.feeDate}] basis and is payable in advance. 
                The ${
                  detail.businessGenre == 'COMPANY' ? 'Company' : 'Fund(s)'
                } shall make fully payment within 14 days from the date of our invoice. If you agree to our above-mentioned fee quotation, 
                our fee schedule is as follows: 
                我们的收费安排为预收收费。其中，年度服务费用按年预收；季度服务费用按季度预收；按需收费的服务事项按开具的发票金额预收。
                贵${
                  detail.businessGenre == 'COMPANY' ? '公司' : '基金'
                }应自收到发票后的14日内完成付款。若您同意我们的上述收费报价，相关的收费（未包括按需收费的服务事项）具体安排如下:`"
                prop="feeDate"
                ref="feeDate"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.feeDate" placeholder="Monthly/Quaterly/Yearly" class="wd500"></el-input>
              </el-form-item>

              <el-form-item
                prop="feeScheduleList"
                ref="feeScheduleList"
                :rules="{
                  type: 'array',
                  required: true,
                  message: 'Please add',
                  trigger: 'submit',
                }"
                class="pt10"
              >
                <el-button
                  @click="quotationUpdateHandle"
                  v-if="
                    (detail.applymentStatus === 'INQUIRING' ||
                      detail.applymentStatus === 'QUOTING' ||
                      detail.applymentStatus === 'QUOTATION_AUDIT_FAIL') &&
                    isApplymentAuth('quotation:coordinate')
                  "
                >
                  Edit Quotation
                </el-button>
                <div class="pt10">
                  <!-- Quotation定制化服务-报价(列表) -->
                  <quotation-list :quotationList="detail.quotationList" :orderInfoList="detail.orderInfoList" :orderRefundList="detail.orderRefundList" />
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="pb50 desp-items-group">
        <p class="desp-items-group-title">5. Ending 结语</p>
        <div class="desp-item">
          <div class="desp-item-self">
            <div class="pb30">
              <p class="lh22">
                5.1 We adhere to the work philosophy of "professional, concentrate, convenience", and is committed to providing professional services with
                quality and efficiency. We target to form a good reputation through our professional services provided, and we welcome more entrepreneurs
                who are interested in overseas development to join our platform to “Develop Together, and Grow Together”.
                我们秉承“专业、专注、专心”的工作理念，将持续为企业提供便捷高效的专业服务。我们希望通过我们专业的服务形成良好的口碑、并结交更多有志于海外发展的企业家，共同发展、共同进步。
              </p>
            </div>
            <div class="pb30">
              <el-form-item
                :label="`5.2 If you have further questions, please contact: [${dataForm.functionary}] [${dataForm.email}]`"
                prop="functionary"
                ref="functionary"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.functionary" placeholder="负责人(EN)" class="wd500"></el-input>
              </el-form-item>
              <el-form-item
                prop="email"
                ref="email"
                :rules="[
                  {
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  },
                  {
                    type: 'email',
                    message: 'Please provide a valid email address',
                    trigger: 'submit',
                  },
                ]"
              >
                <el-input v-model="dataForm.email" placeholder="负责人电邮地址" class="wd500"></el-input>
              </el-form-item>

              <el-form-item
                :label="`5.2 若您有进一步的疑问，请联系: [${dataForm.functionaryCn}] [${dataForm.email}]`"
                prop="functionaryCn"
                ref="functionaryCn"
                :rules="{
                  required: true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.functionaryCn" placeholder="负责人(CN)" class="wd500"></el-input>
              </el-form-item>
            </div>
            <div class="pb30" v-if="detail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
              <el-form-item
                label="Appendix 1 Authorized Persons 附录1 授权名单"
                prop="appendixUrl.url"
                ref="appendixUrl.url"
                :rules="{
                  required: true,
                  message: 'Please upload',
                  trigger: 'submit',
                }"
              >
                <el-image-uploader v-model="dataForm.appendixUrl"></el-image-uploader>
                <el-input v-model="dataForm.appendixUrl.url" style="display: none"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 报价 - 弹框 -->
    <edit-quotation
      ref="editQuotationRef"
      :detail="detail"
      :moduleServiceList="moduleServiceList"
      :supplierList="supplierList"
      :invoiceTemplateList="invoiceTemplateList"
      @updateFeeLetterSomeData="updateFeeLetterSomeData"
    ></edit-quotation>
  </div>
</template>

<script>
import uploader from "@/utils/uploader";
import { validateLocation, base64ToFile } from "@/utils";
import QuotationList from "@/components/ServiceGather/QuotationList";
import EditQuotation from "./modal/EditQuotation";
import { mapActions } from "vuex";
import { governingLawClauseRegistry } from "./governingLawClause";
export default {
  components: {
    QuotationList,
    EditQuotation,
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          id: null,
          applymentStatus: "",
          quotationList: [],
          businessGenre: "",
          businessType: "",
          fundInfoList: [],
          questionnaire: {
            proposedCompanyName: "",
          },
        };
      },
    },
  },
  data() {
    return {
      dataForm: {
        newTransactionNumber: "",
        transactionNumber: "",
        companyName: "",
        fundManagerRole: "",
        fundManagerRoleCn: "",
        introduction: null,
        introductionCn: null,
        principal: "",
        principalCn: "",
        serviceScopeAndFeesUrl: {},
        serviceScopeAndFeesCnUrl: {},
        notes: null,
        notesCn: null,
        feeDate: "",
        feeScheduleList: [],
        functionary: "",
        functionaryCn: "",
        email: "",
        appendixUrl: {},
        fundNameList: [],
      },
      moduleServiceList: [],
      supplierList: [],
      invoiceTemplateList: [],
      channel: null, // 监听通到
      submitLoading: false,
    };
  },
  computed: {
    // 1.6 法律管辖条款，按 detail.country 动态取值，未匹配时显示空
    governingLawClause() {
      const country = this.detail?.country || "";
      return governingLawClauseRegistry[country] || { en: "", cn: "" };
    },
  },
  methods: {
    ...mapActions("applyment", ["saveFeeLetter", "commitQuotation"]),
    // 初始化
    async init() {
      this.submitLoading = false;
      try {
        // 获取收费协议详情
        await this.getFeeLetterDetail();
        // 获取服务商列表
        await this.getSupplierList();
        // 获取发票模板列表
        await this.getInvoiceTemplateList();
        // 获取服务列表
        await this.getModuleList();
      } finally {
        // 更新Fee Letter中的feeScheduleList、companyName
        this.updateFeeLetterSomeData();
      }
    },
    // 修改或新增报价单 - 弹框
    quotationUpdateHandle() {
      this.$refs.editQuotationRef.init();
    },
    // 保存表单
    dataFormSave() {
      this.submitLoading = true;
      this.saveFeeLetter({ applymentId: this.detail.id, content: JSON.stringify(this.dataForm) })
        .then(res => {
          this.$message.success("success");
        })
        .catch(err => {})
        .finally(() => {
          this.submitLoading = false;
        });
    },
    // 提交表单
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          await this.$confirm(`Commit this quotation. Continue?`, "Warning", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          });
          // 开启父组件 Revision Submit 按钮的loading
          this.$emit("updateRevisionSubmitBtnLoading", true);
          try {
            // 先保存数据
            await this.saveFeeLetter({ applymentId: this.detail.id, content: JSON.stringify(this.dataForm) });
            // 再提交
            await this.commitQuotation({
              applymentId: this.detail.id,
            });
            this.$message.success("success");
          } catch (err) {}
          // 关闭父组件 Revision Submit 按钮的loading
          this.$emit("updateRevisionSubmitBtnLoading", false);
        } else {
          validateLocation(object, this);
          return false;
        }
      });
    },
    // 更新Fee Letter中的报价列表(feeScheduleList)和服务商名称列表(companyName)
    updateFeeLetterSomeData() {
      // 从申请单详情中获取报价列表信息
      const detailCopy = JSON.parse(JSON.stringify(this.detail));
      const quotationList = detailCopy?.quotationList || [];
      // 更新dataForm.feeScheduleList仅用于触发el-form必填提示，不做其他用途
      this.$set(this.dataForm, "feeScheduleList", quotationList);
      // 根据申请单详情中的报价列表信息，更新1.4中的服务商名称列表
      const originalCompanyNameList = quotationList.map(item => item?.supplier?.companyName || "");
      // 去重并过滤空值
      const finalCompanyNameList = [...new Set(originalCompanyNameList)].filter(Boolean);
      const companyNameStr = finalCompanyNameList.join(", ");
      this.$set(this.dataForm, "companyName", companyNameStr);
    },
    // 获取服务列表
    getModuleList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/service/list", {
            params: {
              businessType: this.detail.businessType,
              country: this.detail.country,
              status: 1,
            },
          })
          .then(res => {
            const resData = res.data || [];
            this.moduleServiceList = resData.map(item => ({ value: `${item.description} ${item.descriptionCn}`, supplier: item.supplier || {} }));
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取收费协议详情
    getFeeLetterDetail() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/customerFeeLetterManage/getDetailByApplymentId", {
            params: {
              applymentId: this.detail.id,
            },
          })
          .then(res => {
            const resData = res.data || {};
            const resContent = resData.content ? JSON.parse(resData.content) : {};
            // feeScheduleList、companyName是从申请单详情(detail)中获取的，这里不设置
            this.dataForm = {
              newTransactionNumber: resContent.newTransactionNumber || "",
              transactionNumber: resContent.transactionNumber || "",
              fundManagerRole: resContent.fundManagerRole || "Administrator",
              fundManagerRoleCn: resContent.fundManagerRoleCn || "托管人",
              introduction: resContent.introduction || null,
              introductionCn: resContent.introductionCn || null,
              principal: resContent.principal || "",
              principalCn: resContent.principalCn || "",
              serviceScopeAndFeesUrl: resContent.serviceScopeAndFeesUrl || {},
              serviceScopeAndFeesCnUrl: resContent.serviceScopeAndFeesCnUrl || {},
              notes: resContent.notes || "",
              notesCn: resContent.notesCn || "",
              feeDate: resContent.feeDate || "",
              functionary: resContent.functionary || "",
              functionaryCn: resContent.functionaryCn || "",
              email: resContent.email || "",
              appendixUrl: resContent.appendixUrl || {},
              fundNameList: resContent.fundNameList || [],
            };
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            const resData = res.data || [];
            this.supplierList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取发票模板列表
    getInvoiceTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/invoiceTemplate")
          .then(res => {
            const resData = res.data || [];
            // 只保留发票模板，排除退款发票(Credit Invoice)模板
            this.invoiceTemplateList = resData.filter(item => item.invoiceType == 1);
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 接收通道传递的数据
    handleMessage(event) {
      const message = event.data;
      if (!message || message.type !== "request") return;
      if (message.action === "cancel") return;
      if (message.action !== "start") return;
      this.$confirm(`Accept quotation data for "${message.payload?.fqSettings?.customerName}"?`, "Incoming Quotation", {
        confirmButtonText: "Accept",
        cancelButtonText: "Decline",
        type: "warning",
      })
        .then(async _ => {
          // 发送同意消息
          this.handleRespond(message.syncId, "accepted", "CRM accepted the quotation. Processing started.");
          // 解析数据
          const payload = message.payload;
          if (!payload || (!payload.quotationImageBase64 && !payload.fqSettings && (payload.fqRows?.length ?? 0) === 0)) {
            // 无数据时给出提示
            this.$message.warning("No data available for processing.");
            // 发送结束消息
            this.handleRespond(message.syncId, "completed", "CRM ends importing quotation data");
            return;
          }
          const operableStatusList = ["INQUIRING", "QUOTING", "QUOTATION_AUDIT_FAIL"];
          if (!operableStatusList.includes(this.detail.applymentStatus)) {
            // 申请单状态不在可操作状态列表中，给出提示
            this.$message.warning("Operation not allowed in current state.");
            // 发送结束消息
            this.handleRespond(message.syncId, "completed", "CRM ends importing quotation data");
            return;
          }
          if (!this.isApplymentAuth("quotation:coordinate")) {
            // 无操作权限时给出提示
            this.$message.warning("Coordinator permissions required for this action.");
            // 发送结束消息
            this.handleRespond(message.syncId, "completed", "CRM ends importing quotation data");
            return;
          }
          if (payload.quotationImageBase64) {
            const file = base64ToFile(payload.quotationImageBase64, "quotation.png");
            if (file) {
              const res = await uploader.upload(file).catch(error => {
                return null;
              });
              const resData = res?.data || {};
              if (resData?.urls?.length > 0) {
                this.$set(this.dataForm, "serviceScopeAndFeesUrl", resData.urls[0]);
                this.$set(this.dataForm, "serviceScopeAndFeesCnUrl", resData.urls[0]);
              }
            }
          }
          if (payload.fqSettings || payload.fqRows?.length > 0) {
            this.$refs.editQuotationRef.autoInsertData(payload);
          }
          // 发送完成消息
          this.handleRespond(message.syncId, "completed", "CRM completes the import of quotation data");
        })
        .catch(_ => {
          // 发送拒绝消息
          this.handleRespond(message.syncId, "declined", "CRM declined quotation sync");
        });
    },
    // 给通道发送消息
    handleRespond(syncId, status, text) {
      if (!this.channel) return;
      const response = {
        type: "response",
        version: 1,
        syncId: syncId,
        source: "crm",
        status,
        message: text,
        sentAt: new Date().toISOString(),
      };
      this.channel.postMessage(response);
    },
    // 关闭通道
    closeChannel() {
      if (this.channel) {
        this.channel.close();
        this.channel = null;
      }
    },
  },
  activated() {
    // 初始化同名通道
    this.channel = new BroadcastChannel("quotation-crm-sync");
    // 绑定接收事件
    this.channel.onmessage = event => {
      this.handleMessage(event);
    };
  },
  deactivated() {
    this.closeChannel();
  },
  beforeDestroy() {
    this.closeChannel();
  },
};
</script>

<style lang="scss" scoped>
.feeLetterForm {
  p {
    margin: 0;
  }
  ::v-deep {
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-form-item__label {
      line-height: 22px;
    }
  }
}
</style>
